import {
  TextInput,
  TextInputProps,
} from 'components/FormUtils/TextInput/text-input'
import { FieldValues } from 'react-hook-form'
import { cn } from 'components/UI/cn'

export function FilterTextInput<T extends FieldValues>(
  props: Omit<TextInputProps<T>, 'getInputClassName'>
) {
  const getFilterClassName = (isFocused: boolean, hasValue: boolean) => {
    return cn({
      '!border !border-brand-active': isFocused, // Active
      '!border !border-brand': !isFocused && hasValue, // Filled
      '!border !border-fg-muted': !isFocused && !hasValue, // Empty
    })
  }

  return <TextInput {...props} getInputClassName={getFilterClassName} />
}
